import { camelCase, upperFirst } from 'lodash-es'

/**
 * Converts a tack name into a PascalCase hashtag-safe format for social sharing.
 *
 * Social platforms treat hashtags as single tokens, so spaces and special characters
 * must be removed. PascalCase (e.g. "digital art" → "DigitalArt") keeps multi-word
 * tags readable while remaining valid hashtags.
 *
 * For CJK characters, `camelCase` passes them through unchanged since there are
 * no word boundaries to transform.
 */
export function normalizeTackNameForShare(name: string): string {
  return upperFirst(camelCase(name))
}
